export interface StorageState {
  HIDE_INSTALL_EXTENSION_PANEL: boolean
  HIDE_INSTALL_EXTENSION_PANEL_FOREVER: boolean
  HIDE_PAID_CHILICAL_NUDGE_WARNING: boolean
  HIDE_PERSONAL_MEETING_TYPE_WARNING: boolean
  LEFTNAV_STATE: 'collapsed' | 'expanded'
  SHOW_BUFFERS: boolean
  SHOW_DECLINED_EVENTS: boolean
  SHOW_WEEKENDS: boolean
}

const DEFAULT_STORAGE: StorageState = {
  SHOW_BUFFERS: true,
  HIDE_INSTALL_EXTENSION_PANEL_FOREVER: false,
  SHOW_DECLINED_EVENTS: false,
  SHOW_WEEKENDS: false,
  HIDE_PAID_CHILICAL_NUDGE_WARNING: false,
  LEFTNAV_STATE: 'collapsed',
  HIDE_PERSONAL_MEETING_TYPE_WARNING: false,
  HIDE_INSTALL_EXTENSION_PANEL: false,
}

type Subscription = Record<keyof StorageState, Array<(value: any) => void>>

export class Storage {
  static subscriptions: Subscription = Object.keys(DEFAULT_STORAGE).reduce((acc, key) => {
    return {
      ...acc,
      [key]: [],
    }
  }, {} as Subscription)

  static initDefaultValues() {
    Object.keys(DEFAULT_STORAGE).forEach(key => {
      const value = localStorage.getItem(key)
      if (value === undefined || value === null) {
        Storage.set(key as keyof StorageState, DEFAULT_STORAGE[key])
      }
    })
  }

  static get(key: keyof StorageState): StorageState[keyof StorageState] | null {
    const value = localStorage.getItem(key)
    if (value === 'true' || value === 'false') {
      return value === 'true'
    }

    return value as StorageState[keyof StorageState]
  }

  static set(key: keyof StorageState, value: StorageState[keyof StorageState]) {
    const stringValue = typeof value === 'boolean' ? value.toString() : value
    localStorage.setItem(key, stringValue)
    window.dispatchEvent(new Event('storage'))
    Storage.subscriptions[key].forEach(sub => sub(value))
  }

  static getAll(): StorageState {
    return Object.keys(DEFAULT_STORAGE).reduce((acc, key) => {
      const value = Storage.get(key as keyof StorageState)
      return {
        ...acc,
        [key]: value,
      }
    }, {}) as StorageState
  }

  static subscribe<T extends keyof StorageState>(
    key: T,
    callback: (value: StorageState[T]) => void
  ) {
    this.subscriptions[key].push(callback)
    return () => {
      this.subscriptions[key] = this.subscriptions[key].filter(sub => sub !== callback)
    }
  }
}

Storage.initDefaultValues()
